import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './bootstrap-global-reset.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './ThemeContext'; // ✅ import ThemeProvider
import { UserProvider } from './UserContext';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>   {/* ✅ Wrap App with ThemeProvider */}
      <UserProvider>
        <App />
      </UserProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
